<template>
  <section class="invoice-preview-wrapper">
    <b-card no-body>
      <div class="m-2">
        <b-row>
          <b-col md="12">
            <h2>{{ $t("reception.patient-lobby-list") }}</h2>
          </b-col>
          <b-col cols="12" md="12">
            <br />
          </b-col>
          <b-col md="6" cols="12">
            <!-- <h4>Patient Name</h4> -->
            <b-form-group
              :label="$t('reception.patient-name')"
              label-for="Name"
            >
              <b-form-input
                id="Name"
                v-model="patientName"
                :placeholder="$t('reception.patient-name')"
                @keydown.enter="getPatientCards()"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="4"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <!-- <h4></h4> -->
            <b-button
              class="mt-50"
              variant="primary"
              @click="getPatientCards()"
            >
              {{ $t("common.search") }}
              <b-icon-search class="ml-1"></b-icon-search>
            </b-button>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col>
            <b-table
              :items="patientCardsData"
              responsive
              :fields="tableColumns"
              primary-key="id"
              class="position-relative"
              show-empty
              empty-text="No matching patients found"
              v-if="!loading"
            >
              <template #cell(patient.name)="data">
                <span class="text-nowrap text-dark">{{
                  data.item.patient.name
                }}</span>
              </template>
              <template #cell(patient.created_at)="data">
                <span class="text-nowrap text-dark">{{
                  data.item.patient.created_at
                }}</span>
              </template>
              <template #cell(patient_room)="data">
                <ul class="list-unstyled mb-0">
                  <li v-for="room in data.item.patient_room" :key="room.id">
                    <b-badge
                      variant="light"
                      class="text-dark"
                      style="font-size: 15px; margin: 3px"
                    >
                      {{ room.room.name }}
                    </b-badge>
                  </li>
                </ul>
              </template>
              <template #cell(doctors)="data">
                <ul class="list-unstyled mb-0">
                  <li v-for="doctor in data.item.doctors" :key="doctor.id">
                    <b-badge
                      variant="light"
                      class="text-dark"
                      style="font-size: 15px; margin: 3px"
                    >
                      {{ doctor.name }}
                    </b-badge>
                  </li>
                </ul>
              </template>
              <template #cell(stays)="data">
                <div class="stays-container">
                  <div v-for="stay in data.item.stays" :key="stay.id" class="stay-item mb-2 p-2 border-left border-primary">
                    <div class="d-flex align-items-center mb-1">
                      <small class=" mr-2">Date:</small>
                      <span class="font-weight-bold text-nowrap">{{ stay.stay_date_time }}</span>
                    </div>
                    
                    <div v-if="stay.doctors_prices.items.length">
                      <small class="">Doctor{{ stay.doctors_prices.items.length > 1 ? 's' : '' }}:</small>
                      <ul class="pl-3 mb-0 mt-1">
                        <li v-for="doctor in stay.doctors_prices.items" :key="doctor.id" class="doctor-item">
                          {{ doctor.doctor.name }}
                        </li>
                      </ul>
                    </div>
                  </div>
                  
                  <div v-if="!data.item.stays.length" class="text-muted">
                    {{ $t("reception.no-bed-rest") }}
                  </div>
                </div>
              </template>
              <template #cell(surgeries)="data">
                <ul class="list-unstyled mb-0">
                  <li v-for="surgery in data.item.surgeries" :key="surgery.id">
                    <b-badge
                      variant="light"
                      class="text-dark"
                      style="font-size: 15px; margin: 3px"
                    >
                      {{ surgery.surgery.title }}
                    </b-badge>
                  </li>
                </ul>
              </template>
              <template #cell(actions)="data">
                <div class="text-nowrap d-flex">
                  <b-button
                    v-if="$store.state.app.permissions.includes('get-patient')"
                    size="sm"
                    pill
                    variant="outline-secondary"
                    class="mb-75 mx-1"
                    @click="
                      $router.push({
                        name: 'Reception-patient-preview',
                        params: { id: data.item.patient.id },
                      })
                    "
                  >
                    {{ $t("common.preview") }}
                  </b-button>
                  <!-- <b-button
                    v-if="$store.state.app.permissions.includes('get-invoice')"
                    size="sm"
                    pill
                    variant="outline-secondary"
                    class="mb-75 mx-1"
                    @click="
                      $router.push({
                        name: 'invoices',
                        params: { patientId: data.item.patient.id },
                        query: {
                          patientCardId: data.item.id,
                        },
                      })
                    "
                  >
                    {{ $t("hospital.preview-invoices") }}
                  </b-button> -->
                  <b-button
                    v-if="$store.state.app.permissions.includes('get-invoice')"
                    size="sm"
                    pill
                    variant="outline-secondary"
                    class="mb-75 mx-1"
                    @click="
                      $router.push({
                        name: 'out-clinic-invoices',
                        params: {
                          id: data.item.id,
                          name: data.item.patient.name,
                        },
                      })
                    "
                  >
                    {{ $t("reception.out-clinic-invoices") }}
                  </b-button>
                  <b-button
                    size="sm"
                    pill
                    variant="outline-primary"
                    class="mb-75"
                    @click="
                      $router.push({
                        name: 'patient-card-timeline',
                        params: { id: data.item.patient.id },
                      })
                    "
                    >{{ $t("reception.preview-timeline") }}</b-button
                  >
                </div>
              </template>
              <template #cell(phone)="data">
                <span v-if="data.item.patient">{{
                  formatPhoneNumber(data.item.patient.phone)
                }}</span>
              </template>
            </b-table>
            <template v-if="loading">
              <div>
                <div class="d-flex justify-content-center mb-1">
                  <b-spinner label="Loading..." />
                </div>
              </div>
            </template>
          </b-col>
        </b-row>
      </div>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted"
              >{{ $t("common.showing") }} 1 {{ $t("common.to") }} 10
            </span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
            @click="getPatientCards()"
          >
            <b-pagination
              v-model="page"
              :total-rows="dataCount"
              :per-page="take"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </section>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BTable,
  BCardBody,
  BTableLite,
  BCardText,
  BButton,
  BAlert,
  BLink,
  BFormInput,
  BMedia,
  BAvatar,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BFormGroup,
  BFormSelect,
  BSpinner,
  BIconSearch,
  BModal,
} from "bootstrap-vue";
import vSelect from "vue-select";
import PatientSearch from "@/components/patientSearch.vue";
import formatPhoneNumber from "@/utils/formatPhoneNumber";
export default {
  components: {
    BRow,
    BCol,
    BTable,
    BCard,
    BCardBody,
    BTableLite,
    BCardText,
    BButton,
    BAlert,
    BLink,
    vSelect,
    BFormInput,
    BMedia,
    BAvatar,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BModal,
    BIconSearch,
    PatientSearch,
  },
  data() {
    return {
      tableColumns: [
        { key: "patient.name", label: this.$t("common.name"), sortable: true },
        {
          key: "patient.created_at",
          label: this.$t("reception.date-in"),
          sortable: true,
        },
        {
          key: "surgeries",
          label: this.$t("reception.surgeries"),
          sortable: true,
        },
        {
          key: "doctors",
          label: this.$t("reception.doctor-name"),
          sortable: true,
        },
        {
          key: "stays",
          label: this.$t("reception.bed-rest"),
          sortable: true,
        },
        {
          key: "patient_room",
          label: this.$t("common.room"),
          sortable: true,
        },
        {
          key: "type",
          label: this.$t("reception.card-type"),
          sortable: true,
        },

        {
          key: "patient.birth_date",
          label: this.$t("reception.birth-date"),
          sortable: true,
        },
        {
          key: "phone",
          label: this.$t("reception.phone"),
          sortable: true,
          class: "text-nowrap",
        },

        { key: "Actions", label: this.$t("common.actions") },
      ],
      patientCardsData: [],

      page: 1,
      totalRows: "",
      todayDate: "",
      take: 10,
      loading: false,
      selected: "",
      option: [],
      patientName: "",
      dataCount: 0,
    };
  },

  mounted() {
    this.getPatientCards();
  },
  methods: {
    getNestedProperty(obj, path, defaultValue = "N/A") {
      const result = path
        .split(".")
        .reduce(
          (acc, part) => (acc && acc[part] ? acc[part] : defaultValue),
          obj
        );
      // if (typeof result === "string" && result.startsWith("\\")) {
      //   return defaultValue;
      // }
      // console.log("result", result);
      return result;
    },
    // this is trmporary
    formatPhoneNumber,
    async getPatientCards() {
      this.loading = true;
      let url = `/patientCard?include[]=stays&include[]=invoicePatientStay&include[]=doctors&include[]=patientRoom&include[]=surgeries&page=${this.page}&take=${this.take}&sort=-id&filter[is_active]=1`;

      if (this.patientName) {
        url += `&filter[patient.name]=${this.patientName}`;
      }

      await this.getList(url);
      for (let item in this.all_data) {
        if (this.all_data[item] == null) this.all_data[item] = "";
      }
      this.dataCount = this.all_data.total;
      this.patientCardsData = this.all_data.data;
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}

#modal-add___BV_modal_content_ {
  width: 100% !important;
}

#modal-add {
  margin-left: -8% !important;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>

<style scoped>
.stay-item {
  border-left-width: 3px !important;
  background-color: rgba(0, 123, 255, 0.05);
  border-radius: 4px;
}

.doctor-item {
  font-size: 14px;
  margin-bottom: 2px;
}

/* For the last doctor item to remove extra bottom margin */
.doctor-item:last-child {
  margin-bottom: 0;
}
</style>
